module.exports = __webpack_public_path__ + "static/img/p3.dae37b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/p3.jpg
// module id = KUE/
// module chunks = 0